import React from "react";
import ErrorState from "./ErrorState";

export const ErrorComponent = ({ error }) => {
  return (
    <ErrorState
      title="Authenticatiefout"
      message={error?.errorCode || "Er ging iets mis bij het inloggen."}
    />
  );
};
